import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { FlyerApiResponse, FlyerPopupItem, FlyerResponse } from './flyer-popup.models';

@Injectable({
  providedIn: 'root',
})
export class FlyerPopupService {
  private readonly activeFlyersUrl = '/api/v1/flyers/active';

  constructor(private readonly http: HttpClient) {}

  getActiveBackOfficeFlyers(): Observable<FlyerPopupItem[]> {
    return this.http.get<FlyerApiResponse>(this.activeFlyersUrl).pipe(
      map((response) => this.toPopupItems(response)),
    );
  }

  private toPopupItems(response: FlyerApiResponse): FlyerPopupItem[] {
    if (!response.result || !Array.isArray(response.data)) {
      return [];
    }

    return response.data
      .map((flyer) => this.toPopupItem(flyer))
      .filter((flyer): flyer is FlyerPopupItem => flyer !== null);
  }

  private toPopupItem(flyer: FlyerResponse): FlyerPopupItem | null {
    const imageUrl = flyer.imageUrl?.trim();

    if (!imageUrl) {
      return null;
    }

    return {
      id: flyer.id,
      imageUrl,
      alt: this.resolveAlt(flyer),
    };
  }

  private resolveAlt(flyer: FlyerResponse): string {
    return flyer.title?.trim() || flyer.description?.trim() || 'Flyer informativo';
  }
}
